import { useQuery } from '@apollo/client';
import { usePaginationSearch } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  BreederReviewsGetReviewsQuery,
  BreederReviewsGetReviewsQueryVariables,
} from '@gql/graphql';
import { SortOrder } from '@gql/graphql';
import { useMemo } from 'react';

const REVIEWS_PAGINATED_SIZE = 3;
export const BREEDER_REVIEW_GET_REVIEWS = graphql(`
  query BreederReviewsGetReviews(
    $where: DogBreederReviewWhereInput
    $take: Int
    $skip: Int
    $breederWhere: DogBreederWhereInput
    $orderBy: DogBreederReviewOrderByWithRelationAndSearchRelevanceInput!
  ) {
    findManyDogBreeder(where: $breederWhere, take: 1) {
      id
      reviews(take: $take, skip: $skip, where: $where, orderBy: $orderBy) {
        id
        createdAt
        globalGrade
        verified
        description
        contactType
        contactDate
        reviewerPic
        reviewerName
        account {
          id
          firstName
          lastName
          imgs {
            id
            small
          }
        }
        answer {
          content
          createdAt
        }
        breederName
        dogBreeder {
          id
          profileImg
        }
      }
    }
    aggregateDogBreederReview(where: $where) {
      _count {
        _all
      }
      _avg {
        humanContactGrade
        hygieneGrade
        globalGrade
        dogsWellBeingGrade
        followUpGrade
      }
    }
  }
`);

export const useGetReviews = (breederId?: number) => {
  const { currentPage } = usePaginationSearch();

  const variables: BreederReviewsGetReviewsQueryVariables = useMemo(() => {
    return {
      orderBy: { createdAt: SortOrder.desc },
      take: REVIEWS_PAGINATED_SIZE,
      skip: currentPage * REVIEWS_PAGINATED_SIZE,
      breederWhere: { id: { equals: breederId } },
      where: {
        dogBreederId: { equals: breederId },
      },
    } as BreederReviewsGetReviewsQueryVariables;
  }, [breederId, currentPage]);

  const { data, error, loading, refetch } = useQuery<
    BreederReviewsGetReviewsQuery,
    BreederReviewsGetReviewsQueryVariables
  >(BREEDER_REVIEW_GET_REVIEWS, {
    variables,
    skip: breederId == null,
  });
  return {
    breederReviews: data?.findManyDogBreeder?.[0]?.reviews,
    breederReviewsAggregate: data?.aggregateDogBreederReview,
    breederReviewsError: error,
    breederReviewsLoading: loading,
    breederReviewsVariables: variables,
    breederReviewsRefetch: refetch,
  };
};
